<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <b-card border-variant="light" class="card-doc">
                <b-card-title class="text-dark font-20 font-weight-bold"
                    >Thống kê tình hình các trạm</b-card-title
                >
                <b-table
                    class="mt-2"
                    striped
                    hover
                    :items="listStationDisplay"
                    :fields="fields"
                    show-empty
                >
                    <template #cell(index)="data">{{
                        (currentPage - 1) * CONSTANTS.ITEM_PER_PAGE + (data.index + 1)
                    }}</template>
                    <template v-slot:cell(code)="row">
                        <b-badge class="px-2 py-1 font-12" :variant="getVariantColor(row.value)">{{
                            getWaterStatus(mapCurrentWater[row.value])
                        }}</b-badge>
                    </template>
                    <template v-slot:empty>
                        <div class="text-center">
                            <span>Không có bản ghi nào</span>
                        </div>
                    </template>
                </b-table>
                <hr />
                <b-card-title class="text-dark font-20 font-weight-bold">
                    <b-row>
                        <b-col>Thống kê so sánh dữ liệu giữa các trạm</b-col>
                    </b-row>
                </b-card-title>
                <CompareChart />
            </b-card>
        </div>
    </div>
</template>

<script>
import CONSTANTS from '@/constants';
import { mapActions, mapState } from 'vuex';
import CompareChart from '@/components/CompareChart';
export default {
    components: {
        CompareChart
    },
    async mounted() {
        await this.$nextTick();
        this.getList();
        this.getWaterData({
            date: this.$moment().format('DD/MM/YYYY'),
            type: CONSTANTS.GEOJSON_TYPE.CURRENT_RAIN,
            hour: this.$moment().format('HH')
        });
    },
    data() {
        return {
            CONSTANTS,
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'name', label: this.$i18n.t('common.name') },
                {
                    tdClass: 'align-middle',
                    key: 'description',
                    label: this.$i18n.t('common.description')
                },
                {
                    tdClass: 'align-middle',
                    key: 'code',
                    label: 'Tình trạng'
                }
            ],
            currentPage: 1
        };
    },
    computed: {
        ...mapState({
            items: (state) => state.station.items,
            listWaterEachStation: (state) => state.station.listWater
        }),
        mapCurrentWater() {
            const waterValue = {};
            this.listWaterEachStation.forEach((element) => {
                waterValue[element.stationCode] = element.value;
            });
            return waterValue;
        },
        listStationDisplay() {
            return this.items.filter((item) => item.code.includes('F00'));
        }
    },
    methods: {
        ...mapActions({
            getList: 'station/getList',
            getWaterData: 'station/getListStationWater'
        }),
        getWaterStatus(value) {
            return value > 20
                ? 'Mưa rất to'
                : value > 10
                ? 'Mưa to'
                : value > 5
                ? 'Mưa vừa'
                : value > 0
                ? 'Mưa nhỏ'
                : 'Không mưa';
        },
        getVariantColor(value) {
            let data = this.mapCurrentWater[value];
            return data > 20
                ? 'danger'
                : data > 10
                ? 'warning'
                : data > 5
                ? 'secondary'
                : data > 0
                ? 'info'
                : 'primary';
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
